import { BordOneToneIcon, NudosButton } from 'components/NudosComponents';
import './PurcharseOrderConfirmationModalContent.scss';

interface IPurcharseOrderConfirmationModal {
  handleCloseAcceptConfirmationModal: () => void;
  handleAcceptUpdatePurchaseOrder: () => Promise<void>;
}

export const PurcharseOrderConfirmationModalContent = ({
  handleCloseAcceptConfirmationModal,
  handleAcceptUpdatePurchaseOrder
}: IPurcharseOrderConfirmationModal) => {
  return (
    <section className="purcharseOrderConfirmationModalContent">
      <div className="modalHeader">
        <BordOneToneIcon variant="triangleAlertCircle" customWidth="48px" color="yellow" />
      </div>
      <div className="modalBody">
        <p>
          Al guardar el número de PO, se <b>generará automáticamente la factura</b>. Asegúrate de que el número ingresado sea
          correcto para evitar la cancelación de la factura.
        </p>
        <p>¿Seguro que deseas continuar?</p>
      </div>
      <div className="modalFooter">
        <NudosButton 
          buttonText={"No, cancelar"}
          colorPalette='secondary'
          handleClick={() => handleCloseAcceptConfirmationModal()}
        />
        <NudosButton 
          buttonText={"Sí, generar factura"}
          colorPalette='primary'
          handleClick={() => handleAcceptUpdatePurchaseOrder()}
        />
      </div>
    </section>
  );
};
